import React from 'react'
import { Link } from 'gatsby'
import { Summary } from '@/components/Article/style.css'

const SummaryComponent = () => {
  return (
    <Summary>
      <div className="container mx-auto max-w-5xl">
        <h1 className="text-center">
          <strong>Sumario</strong>
        </h1>
        <div className="list">
          <ul>
            <li>
              <Link to="/ranking-shanghai/">
                Ranking Shanghai: Academic Ranking of World Universities (ARWU)
              </Link>
            </li>

            <li>
              <Link to="/ranking-qs-world/">
                Ranking QS: World University Rankings
              </Link>
              <ul>
                <li>
                  <Link to="/ranking-qs-world-chilenos/">
                    Los 20 campus chilenos en el QS World
                  </Link>
                </li>
                <li>
                  <Link to="/ranking-qs-latam/">
                    QS Latin America University Rankings 2022
                  </Link>
                </li>
                <li>
                  <Link to="/ranking-qs-chile/">
                    QS LatAm: el club de las 40
                  </Link>
                </li>
              </ul>
            </li>
            <li>
              <Link to="/ranking-the-world/">
                Ranking THE: The World University Rankings
              </Link>
              <ul>
                <li>
                  <Link to="/ranking-the-chile/">
                    THE-CHL: El auge de las privadas
                  </Link>
                </li>
                <li>
                  <Link to="/ranking-the-latam/">
                    THE Latin America University Rankings 2021
                  </Link>
                </li>
                <li>
                  <Link to="/ranking-the-latam-chile/">
                    Las mejores 28 chilenas en el THE Latam
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Summary>
  )
}

export default SummaryComponent
